export default __webpack_public_path__ + "atomic/_patterns/02-molecules/social-media/_social-media.twig";